import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

import surveyJSON from "./surveyJSON.json";
import "./assets/css/db-konfigurator.css";

Vue.use(Vuex);

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

Sentry.init({
  dsn: "https://b193fbe6fb7c4b4ab35a61f1f0ee96c6@sentry.db-ops.de/6",
  integrations: [new VueIntegration({ Vue, attachProps: true })],
});

const store = new Vuex.Store({
  state: {
    pages: [],
    selectedProducts: [],
    activePage: "start", //start, questionaire, productList, customerForm
    surveyJSON,
    results: null,
    submitted: false,
    products: null,
    survey: null,
  },
  mutations: {
    setPages(state, pages) {
      state.pages = pages;
    },

    setProducts(state, products) {
      state.products = products;
    },

    setSelectedProduct(state, payload) {
      //state.selectedProducts[payload.name] = payload.id;
      state.selectedProducts[payload.name] = payload.id;
      console.log(state.selectedProducts);
    },

    setActivePage(state, page) {
      document.getElementById("dBConfigurator").scroll(0, 0);
      console.log("active page " + page);
      state.activePage = page;
    },

    setResults(state, results) {
      state.results = results;
      console.log(results);
    },

    setSubmit(state, status) {
      state.submitted = status;
    },

    setSurvey(state, survey) {
      state.survey = survey;
    },
  },
});

const requireComponent = require.context("./components", false, /.*\.vue$/);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});

new Vue({
  render: (h) => h(App),
  store: store,
}).$mount("#dBConfigurator");
